export const BUTTONS_GAP_PX = 12;
